var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sd-button',{attrs:{"id":"btn-valuation-request","size":100,"has-full-width":"","isDisabled":!_vm.getPhonenumberIsValid},on:{"click":_vm.requestValuation}},[_vm._v(" Jetzt anfragen ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }